function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton } from '@ori-ui/components';
import { ArrowRightSubmit } from '@ori-ui/icons';
import { Grid, styled } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import { useCallback, useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useConfiguration } from '../contexts';
import { TranslationKey } from '../models';
var AccountRootStyled = styled('div')(function(param) {
    var theme = param.theme;
    return _define_property({
        background: theme.palette.grey[100]
    }, theme.breakpoints.up('sm'), {
        padding: theme.spacing(12, 0, 8)
    });
});
var AccountWrapper = styled('div')(function(param) {
    var theme = param.theme;
    return _define_property({
        padding: theme.spacing(6, 3),
        position: 'relative',
        background: theme.palette.background.default,
        boxSizing: 'border-box'
    }, theme.breakpoints.up('sm'), {
        margin: theme.spacing(-2, 'auto'),
        padding: theme.spacing(6, 12),
        maxWidth: '450px',
        borderRadius: theme.shape.largeComponentRadius
    });
});
var HeaderStyled = styled('div')(function(param) {
    var theme = param.theme;
    return {
        marginBottom: theme.spacing(5),
        padding: theme.spacing(0, 5),
        fontSize: '25px',
        fontWeight: 'bold'
    };
});
var IconButtonStyled = styled(IconButton)(function(param) {
    var theme = param.theme;
    return _define_property({
        position: 'absolute',
        top: '27px',
        left: '5px',
        transform: 'rotate(180deg)',
        '& svg': {
            width: '25px',
            height: '25px',
            fill: theme.palette.default.main
        }
    }, theme.breakpoints.up('sm'), {
        left: '10px'
    });
});
export var Account = function(props) {
    var title = props.title, children = props.children, handleBackBtn = props.handleBackBtn, _props_showBackBtn = props.showBackBtn, showBackBtn = _props_showBackBtn === void 0 ? true : _props_showBackBtn, _props_isLoginPage = props.isLoginPage, isLoginPage = _props_isLoginPage === void 0 ? false : _props_isLoginPage;
    var getTestId = useTestId().getTestId;
    var _useConfiguration = useConfiguration(), returnUrl = _useConfiguration.returnUrl, antiForgeryToken = _useConfiguration.antiForgeryToken, tenant = _useConfiguration.tenant, onlineBaseUrl = _useConfiguration.onlineBaseUrl;
    var reset = useFormContext().reset;
    var formRef = useRef(null);
    var navigate = useNavigate();
    var urlParams = {
        ReturnUrl: returnUrl
    };
    var newParams = new URLSearchParams(urlParams).toString();
    var handleAccountRedirect = useCallback(function() {
        if (handleBackBtn) {
            reset({
                NewPassword: '',
                CurrentPassword: '',
                Password: ''
            });
            return navigate(-1);
        }
        if (isLoginPage) {
            window.location.href = onlineBaseUrl;
        }
        return navigate({
            pathname: '/',
            search: newParams
        });
    }, [
        handleBackBtn,
        isLoginPage,
        navigate,
        newParams,
        onlineBaseUrl,
        reset
    ]);
    return /*#__PURE__*/ _jsx(AccountRootStyled, {
        children: /*#__PURE__*/ _jsxs(AccountWrapper, {
            "data-testid": getTestId('account-wrapper'),
            children: [
                showBackBtn ? /*#__PURE__*/ _jsx(IconButtonStyled, {
                    variant: "text",
                    color: "default",
                    "data-testId": getTestId('account-back-button'),
                    onClick: handleAccountRedirect,
                    "aria-label": TranslationKey.BackButton,
                    children: /*#__PURE__*/ _jsx(ArrowRightSubmit, {})
                }) : null,
                /*#__PURE__*/ _jsxs(HeaderStyled, {
                    children: [
                        isLoginPage ? /*#__PURE__*/ _jsxs("form", {
                            ref: formRef,
                            method: "post",
                            children: [
                                /*#__PURE__*/ _jsx("input", {
                                    type: "hidden",
                                    name: "button",
                                    value: "cancel"
                                }),
                                /*#__PURE__*/ _jsx("input", {
                                    readOnly: true,
                                    type: "hidden",
                                    name: "__RequestVerificationToken",
                                    value: antiForgeryToken
                                }),
                                /*#__PURE__*/ _jsx("input", {
                                    readOnly: true,
                                    type: "hidden",
                                    name: "tenant",
                                    value: tenant
                                }),
                                /*#__PURE__*/ _jsx("input", {
                                    type: "hidden",
                                    name: "ReturnUrl",
                                    value: returnUrl
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ _jsx(Grid, {
                            textAlign: "center",
                            children: title
                        })
                    ]
                }),
                children
            ]
        })
    });
};
